export default function FloatingActions() {
  const actions = [
    {
      id: 'phone',
      label: 'Ring til Casper DJ på +45 30 40 50 06',
      href: 'tel:+4530405006',
      iconClass: 'fa-solid fa-phone',
      bgClass: 'bg-gold-400 hover:bg-gold-300 text-neutral-950 shadow-gold-500/25',
    },
    {
      id: 'email',
      label: 'Send e-mail til INFO@CASPERDJ.DK',
      href: 'mailto:INFO@CASPERDJ.DK',
      iconClass: 'fa-solid fa-envelope',
      bgClass: 'bg-neutral-900 hover:bg-neutral-800 text-white border border-white/10 shadow-black/50',
    },
  ]

  return (
    <aside
      aria-label="Hurtig kontakt"
      className="fixed bottom-6 right-5 sm:right-6 z-50 flex flex-col gap-3 pointer-events-auto"
    >
      {actions.map((action) => (
        <a
          key={action.id}
          href={action.href}
          aria-label={action.label}
          className={`w-12 h-12 sm:w-13 sm:h-13 rounded-full flex items-center justify-center shadow-2xl transition-all duration-300 ease-out hover:scale-110 active:scale-95 cursor-pointer ${action.bgClass}`}
        >
          <i
            className={`${action.iconClass} text-base sm:text-lg flex items-center justify-center leading-none`}
            aria-hidden="true"
          />
        </a>
      ))}
    </aside>
  )
}
